import config from 'config'
import RoutingMenu from 'LIBRARY/CommonResources/RoutingMenu/RoutingMenu'
import React from 'react'
import "./PurchaseRequest.css"

export const PurchaseRequest = () => {
  return (
        <>
        <RoutingMenu activeScreen="purchaseRequest" />
    <div className=''>

        <iframe
            src={`${config.RootUrl}/faculty/library/PRgenaration/PRgenaration.php?isIframe=true`}
            className="iframe col-md-12"
        >
        </iframe>
    </div>
    </>
  )
}
